module.exports = __webpack_public_path__ + "img/ozono.95ef7098.webp";